<template>
  <modal width="35" :show-modal="showModal" @close-modal="$emit('close-modal')">
    <div class="delete-modal">
      <div class="flex justify-center">
        <img
          src="@/assets/images/icons/new-delete.svg"
          alt="Delete illustration"
          class="img-fluid"
        />
      </div>
      <div class="my-6">
        <p>Are you sure you want to cancel this booking?</p>
      </div>
      <div>
        <base-button :loading="loading" @click="cancelBooking" text="Yes, Cancel" />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    booking: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      id: "cancel",
      loading: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    async cancelBooking() {
      try {
        this.loading = true;
        await this.$_updateShippingStatusByDriver(this.booking.id, {
          deliveryStatus: "cancelled",
        });
        this.generateToast("Booking Canceled!", "success");
        this.loading = false;
        this.$emit("booking-subaction-completed");
        this.closeModal()
      } catch (error) {
        this.loading = false;
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped>
.delete-modal {
  text-align: center;
}
</style>
